import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const DiagnosisIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M20 4H15C15 3.448 14.552 3 14 3H10C9.448 3 9 3.448 9 4H4C2.895 4 2 4.895 2 6V18C2 19.105 2.895 20 4 20H20C21.105 20 22 19.105 22 18V6C22 4.895 21.105 4 20 4ZM15 13H13V15C13 15.552 12.552 16 12 16C11.448 16 11 15.552 11 15V13H9C8.448 13 8 12.552 8 12C8 11.448 8.448 11 9 11H11V9C11 8.448 11.448 8 12 8C12.552 8 13 8.448 13 9V11H15C15.552 11 16 11.448 16 12C16 12.552 15.552 13 15 13Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

DiagnosisIcon.propTypes = {
  sx: PropTypes.object,
};

export default DiagnosisIcon;
